import { render, staticRenderFns } from "./AddressModel.vue?vue&type=template&id=47300340&scoped=true"
import script from "./AddressModel.vue?vue&type=script&lang=js"
export * from "./AddressModel.vue?vue&type=script&lang=js"
import style0 from "./AddressModel.vue?vue&type=style&index=0&id=47300340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47300340",
  null
  
)

export default component.exports